import { render, staticRenderFns } from "./SelfEsteem.vue?vue&type=template&id=9b23ccd8&"
import script from "./SelfEsteem.vue?vue&type=script&lang=js&"
export * from "./SelfEsteem.vue?vue&type=script&lang=js&"
import style0 from "./SelfEsteem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports